<div class="button-icon-container" [class]="{'button-icon-container-active': active}">
    <app-icon *ngIf="icon" class="icon" [icon]="icon" [invert]="!active ? 0.45 : 1"/>
    <div class="title">{{ title }}</div>
</div>
